export class CustomerUser {

  public id: number;
  public login: string;
  public email: string;
  public mobile: string;
  public firstName: string;
  public lastName: string;
  public customerPlanningAllowed: boolean;
  public contactSharingToWorkerAllowed: boolean;
  public hierarchicalNature: string;
  jwtToken: string;
  pbiEmbedAllowed: boolean;

  public static fromJson(json: CustomerUser): CustomerUser {
    let cu = new CustomerUser();
    cu.id = json['id'];
    cu.login = json['login'];
    cu.email = json['contactEmail'];
    cu.mobile = json['contactMobile'];
    cu.firstName = json['contactFirstName'];
    cu.lastName = json['contactLastName'];
    cu.customerPlanningAllowed = json['customerPlanningAllowed'];
    cu.contactSharingToWorkerAllowed = json['contactSharingToWorkerAllowed'];
    cu.hierarchicalNature = json['hierarchicalNature'];
    cu.pbiEmbedAllowed = json['pbiEmbedAllowed'];
    return cu;
  }


  /**
   * utility method to display the full name, with first and last name
   * @returns {string}
   */
  fullName(): string {
    let v = '';
    if (this.firstName != null) v += this.firstName;
    if (this.firstName != null && this.lastName != null) v += ' ';
    if (this.lastName != null) v += this.lastName;

    //if we have no name set, we can at least display the login
    if (v.length <= 0)
      v += this.login;

    return v;
  }
}



// WEBPACK FOOTER //
// ./src/model/CustomerUser.ts